import React, { useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Carousel,
  Col,
  Container,
  Row,
} from "react-bootstrap";
import { useNavigate, useLocation } from "@reach/router";
import useSWR from "swr";
import { Facebook as FacebookLoader } from "react-content-loader";

import fetcher from "libs/swr";
import { useAppContext } from "libs/contextLib";

import BigSpinner from "components/BigSpinner";
import GenericError from "components/GenericError";
import SubscriptionPlansList from "components/SubscriptionPlansList";

import { STUDENT_URLS, TEACHER_URLS } from "constants/urls";
import { SUBSCRIPTION_PLANS_HEADING } from "constants/course-details";

import "./course-details.scss";

function CourseDetails(props) {
  const { authenticatedUser, authenticateUser } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();
  const isLearnDomain = props.domain === "learn";

  const courseURL = isLearnDomain
    ? STUDENT_URLS.COURSE(props.courseId)
    : TEACHER_URLS.COURSE(props.courseId);
  const { data: course, error } = useSWR(courseURL, fetcher);

  useEffect(() => {
    if (!isLearnDomain && authenticatedUser === null) {
      navigate("/login?redirect=" + location.pathname);
    }
  });

  if (!isLearnDomain) {
    if (authenticatedUser === false) {
      return (
        <Container>
          <BigSpinner />
        </Container>
      );
    } else if (authenticatedUser === null) {
      return null;
    }
  }
  if (!course && !error) {
    return <FacebookLoader foregroundColor="#F6C6C6" />;
  } else if (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      authenticateUser(null);
    }
    // TODO: Show error code specific errors:
    // - Not authorized on 403
    // - Try again on timeout

    return (
      <Row>
        <Col xs={10} md={8} style={{ height: "50vh" }}>
          <GenericError />
        </Col>
      </Row>
    );
  } else {
    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={`/${props.domain}`}>Home</Breadcrumb.Item>
          <Breadcrumb.Item active>{course.name}</Breadcrumb.Item>
        </Breadcrumb>
        <Container className="course-details">
          <Row>
            <Col
              md={12}
              lg={6}
              className="align-self-center course-carousel-col"
            >
              <Carousel>
                {course.imageUrls.map((item) => (
                  <Carousel.Item key={item}>
                    <img
                      className="w-100 rounded"
                      src={item}
                      alt="course cover"
                      style={{
                        objectFit: "cover",
                        maxHeight: "400px",
                      }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </Col>
            <Col md={12} lg={6}>
              <div className="course-name">{course.name}</div>
              <div className="course-schedule">{course.schedule}</div>

              <div className="teacher-name-div">
                <span>by</span>
                <span className="teacher-name-span">
                  {" " +
                    course.teacher.firstName +
                    " " +
                    (course.teacher.lastName || "")}
                </span>
              </div>
              {/* <span className="course-title-separator">{" | "}</span> */}
              <div className="course-description">{course.description}</div>
              <div className="border my-3 mx-2"></div>
              {course.latestClass ? (
                <div className="mt-4 latest-class-div">
                  <Row className="text-nowrap flex-nowrap">
                    <Col sm={2} className="h5 mb-3">
                      Upcoming classes
                    </Col>
                    <Col sm={10} className="text-right h5 mb-3">
                      <Button
                        className="p-0 m-0 all-classes-link"
                        variant="link"
                        onClick={() =>
                          navigate(`learn/course/${course.id}/classes`)
                        }
                      >
                        {"View all classes >"}
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mx-1 p-2 border rounded bg-light">
                    <Col
                      sm={3}
                      style={{ height: "100px" }}
                      className="d-none d-sm-block"
                    >
                      <img
                        alt="class-cover"
                        src={course.latestClass.imageUrls[0]}
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                        className="img-fluid rounded"
                      />
                    </Col>
                    <Col xs={12} sm={9}>
                      <Row className="justify-content-between">
                        <Col xs="auto font-weight-bold">
                          {course.latestClass.name}
                        </Col>
                        <Col
                          xs="auto"
                          className="rounded px-3 py-1"
                          style={{ background: "lightgray" }}
                        >
                          {course.latestClass.isStreamedLive ? "Live" : "Rec"}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <li>
                            {new Date(
                              course.latestClass.startTime * 1000
                            ).toDateString() +
                              ", " +
                              new Date(
                                course.latestClass.startTime * 1000
                              ).toLocaleTimeString("en-US", {
                                hour: "numeric",
                                minute: "numeric",
                                hour12: true,
                              })}
                          </li>
                          <li>{course.latestClass.duration / 60} mins</li>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              ) : null}
            </Col>
          </Row>

          <Row>
            {" "}
            <Col className="my-3 h3">{SUBSCRIPTION_PLANS_HEADING}</Col>
          </Row>
          <SubscriptionPlansList course={course} domain={props.domain} />
          {!course.allowPlanSelection ? (
            <Row>
              <Col className="font-italic mb-3 text-muted">
                {course.disallowReason}
              </Col>
            </Row>
          ) : null}
        </Container>
      </>
    );
  }
}

export default CourseDetails;
